/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { useContext, useEffect } from 'react';
import {
  useLocation,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from 'react-router-dom';
// reactstrap components
import { Container, Row, Col } from 'reactstrap';
import { GlobalContext } from '../api/GlobalContext';

// core components
import AuthNavbar from 'components/Navbars/AuthNavbar.js';
import AuthFooter from 'components/Footers/AuthFooter.js';

import routes from 'routes.js';

const Auth = (props) => {
  // Get the API
  const { apiClient } = useContext(GlobalContext);

  // Get the navigation function
  const navigate = useNavigate();
  const location = useLocation();

  // Is our apiClient sessionKey null? If not, redirect home
  useEffect(() => {
    let isCurrentRoute = true;

    apiClient.checkExpiration().then((data) => {
      const pathname = location.pathname.toLowerCase();
      if (
        isCurrentRoute &&
        data === true &&
        pathname !== '/auth/reset/password' &&
        pathname !== '/auth/reset/email' &&
        pathname !== '/auth/verify/email' &&
        pathname !== '/auth/verify/sent' &&
        pathname !== '/auth/verify/phone'
      ) {
        console.log(
          'Went to auth and already have session key. Forwarding to Home',
        );
        // if path includes /micRequest then don't navigate to home
        if (pathname !== '/auth/micrequest') {
          navigate('/');
        }
      }
    });

    return () => {
      isCurrentRoute = false;
    };
  }, [apiClient, location.pathname, navigate]);

  const mainContent = React.useRef(null);

  React.useEffect(() => {
    document.body.classList.add('bg-default');
    return () => {
      document.body.classList.remove('bg-default');
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
    if (window.Appcues) {
      window.Appcues.page();
    }
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="main-content" ref={mainContent}>
        <AuthNavbar />
        <div className="header bg-gradient-green py-7 py-lg-8">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <h1 className="text-white">Welcome to Comprehend PT!</h1>
                  <p className="text-lead text-white">
                    We have made it our mission to eliminate documentation with
                    the help of AI! To see the tool we have built in action,
                    please login or register below.
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        {/* Page content */}
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </>
  );
};

export default Auth;
